import {
  BooklaAdminCompanySettings,
  CompanyContact,
  CompanyContent,
  CompanyDetails,
  CompanyStatus,
  CompanyTranslation,
} from '@src/@data/types/company';
import { Image } from '@src/@data/types/common';
import { Dispatch } from 'react';
import { CompanyAction, CompanyActionType } from './actions';

export const reducer = (
  state: CompanyDetails | undefined,
  action: CompanyAction
): CompanyDetails | undefined => {
  switch (action.type) {
    case CompanyActionType.SET_COMPANY:
      return action.company;
    case CompanyActionType.CLEAR_COMPANY:
      return undefined;
  }
  if (!state) {
    return state;
  }
  switch (action.type) {
    case CompanyActionType.UPDATE_TRANSLATIONS:
      return { ...state, translations: action.translations };
    case CompanyActionType.UPDATE_CONTACTS:
      return { ...state, contacts: action.contacts };
    case CompanyActionType.UPDATE_CONTENT:
      return { ...state, content: action.content };
    case CompanyActionType.UPDATE_IMAGE:
      return { ...state, image: action.image };
    case CompanyActionType.UPDATE_ENABLED:
      return {
        ...state,
        status: action.enabled
          ? CompanyStatus.Enabled
          : CompanyStatus.DisabledByOwner,
      };
    case CompanyActionType.LEGAL_INFO_UPDATED:
      return { ...state, hasSignedAgreement: true };
    case CompanyActionType.UPDATE_ADMIN_SETTINGS:
      return { ...state, adminSettings: action.settings };
  }
};

export const handleSetCompany = (
  dispatch: Dispatch<CompanyAction>,
  company: CompanyDetails
) =>
  dispatch({
    type: CompanyActionType.SET_COMPANY,
    company,
  });

export const handleClearCompany = (dispatch: Dispatch<CompanyAction>) =>
  dispatch({
    type: CompanyActionType.CLEAR_COMPANY,
  });

export const handleUpdateTranslations = (
  dispatch: Dispatch<CompanyAction>,
  translations: CompanyTranslation[]
) =>
  dispatch({
    type: CompanyActionType.UPDATE_TRANSLATIONS,
    translations,
  });

export const handleUpdateContacts = (
  dispatch: Dispatch<CompanyAction>,
  contacts: CompanyContact[]
) =>
  dispatch({
    type: CompanyActionType.UPDATE_CONTACTS,
    contacts,
  });

export const handleUpdateContent = (
  dispatch: Dispatch<CompanyAction>,
  content: CompanyContent
) =>
  dispatch({
    type: CompanyActionType.UPDATE_CONTENT,
    content,
  });

export const handleUpdateImage = (
  dispatch: Dispatch<CompanyAction>,
  image: Image
) =>
  dispatch({
    type: CompanyActionType.UPDATE_IMAGE,
    image,
  });

export const handleCompanyUpdateEnabled = (
  dispatch: Dispatch<CompanyAction>,
  enabled: boolean
) =>
  dispatch({
    type: CompanyActionType.UPDATE_ENABLED,
    enabled,
  });

export const handleLegalInfoUpdated = (dispatch: Dispatch<CompanyAction>) =>
  dispatch({
    type: CompanyActionType.LEGAL_INFO_UPDATED,
  });

export const handleUpdateAdminSettings = (
  dispatch: Dispatch<CompanyAction>,
  settings: BooklaAdminCompanySettings
) =>
  dispatch({
    type: CompanyActionType.UPDATE_ADMIN_SETTINGS,
    settings,
  });
